import { IconButton } from '@mui/material'
import { Edit as EditIcon } from '@mui/icons-material'
import { Dispatch, SetStateAction } from 'react'
import { OpenLogResultModal, WaterlineTestResult } from '../types'

type EditResultButton = {
  testResult: WaterlineTestResult,
  setOpenModal: Dispatch<SetStateAction<OpenLogResultModal>>,
}

const EditResultButton = (props: EditResultButton) => {
  const { testResult, setOpenModal } = props

  const handleClick = () => {
    setOpenModal({ open: true, testResult })
  }

  return (
    <IconButton
      onClick={handleClick}
      sx={{ width: '16px', height: '16px' }}
    >
      <EditIcon
        fontSize="small"
        sx={{ width: '16px' }}
      />
    </IconButton>
  )
}

export default EditResultButton
